export var PurchaseFlowPane;
(function (PurchaseFlowPane) {
    PurchaseFlowPane[PurchaseFlowPane["SignIn"] = 0] = "SignIn";
    PurchaseFlowPane[PurchaseFlowPane["CreateAccount"] = 1] = "CreateAccount";
})(PurchaseFlowPane || (PurchaseFlowPane = {}));
